import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { verifyAsync } from "./operations";
import { VerifyUserState } from "./state";

const initialState: VerifyUserState = {
  apps: {
    email: "",
    code: "",
    executeState: "none",
  },
  domains: {},
};

export const verifyUserSlice = createSlice({
  name: "VerifyUser",
  initialState,
  reducers: {
    changeEmail: (state, action: PayloadAction<{ email: string }>) => {
      const { email } = action.payload;
      state.apps.email = email;
    },
    changeCode: (state, action: PayloadAction<{ code: string }>) => {
      const { code } = action.payload;

      state.apps.code = code;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verifyAsync.pending, (state) => {
      /* Empty Function */
      state.apps.executeState = "none";
    });
    builder.addCase(verifyAsync.fulfilled, (state) => {
      /* Empty Function */
      state.apps.executeState = "success";
    });
    builder.addCase(verifyAsync.rejected, (state) => {
      state.apps.executeState = "failed";
    });
  },
});
export const { changeCode, changeEmail } = verifyUserSlice.actions;
export default verifyUserSlice.reducer;
